import { Button, Modal } from "../../components/ui/index.ts";
import type { Workstream } from "./types.ts";
import styles from "./delete-workstream-modal.module.css";

interface DeleteWorkstreamModalProps {
  workstream: Workstream | null;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export function DeleteWorkstreamModal({
  workstream,
  deleting,
  onClose,
  onConfirm,
}: DeleteWorkstreamModalProps) {
  return (
    <Modal
      open={workstream != null}
      onClose={deleting ? () => undefined : onClose}
      title="Delete Work Stream"
      size="sm"
      closeOnEscape
      footer={
        <div className={styles.actions}>
          <Button variant="light-grey" onClick={onClose} disabled={deleting}>Cancel</Button>
          <Button variant="danger" onClick={() => void onConfirm()} disabled={deleting}>
            {deleting ? "Deleting..." : "Delete"}
          </Button>
        </div>
      }
    >
      <p className={styles.message}>
        Are you sure you want to delete <strong>{workstream?.workstream}</strong>? This action cannot be undone.
      </p>
    </Modal>
  );
}
